import React from 'react';
import StylesType from '@/types/StylesType'
import classnames from 'classnames'
import {inject, observer} from 'mobx-react'
import './style.less';
import Table from '@/components/Table'

export enum detailStatus {
    '分配失败' = -1,
    '申请中',
    '处理成功',
    '暂停中',
    '已释放'
}

export interface OrderDetailTypes{
    orderDetail: any[];
}

const OrderDetail: React.FC<StylesType&OrderDetailTypes> =inject('UserStore')(observer( props => {
    const {prefixCls = 'gc_order_detail_', orderDetail=[]} = props
    const columns = [
        {
            title: '设备ID',
            width: '625px',
            dataIndex: 'id'
        }, {
            title: '状态',
            dataIndex: 'status',
            render:(text: detailStatus, record: any)=> <span className={classnames(prefixCls+'status',prefixCls+'status'+text)}>{detailStatus[text]}</span>
        }
    ]

    return (
        <div className={prefixCls + 'table'}>
            <Table rowKey='id' columns={columns} dataSource={orderDetail} pagination={false} scroll={{y: 500}}></Table>
        </div>
    )

}))

export default OrderDetail;
